import React, { useMemo } from "react";
import "../styles/CustomThreadHeader.css";
import { faXmark, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Button, FaIcon } from "../shared/ui";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { useMobileStyles } from "../hooks/useMobileStyles";

const CustomThreadHeader = ({ closeThread }) => {
  const { channel } = useChannelStateContext();
  const { client } = useChatContext();

  const { colorStyle, bgColorStyle } = useMobileStyles();

  const otherMember = useMemo(() => {
    const members = Object.values(channel.state.members);
    return members.find((member) => member.user?.id !== client.userID)?.user;
  }, [channel, client]);

  return (
    <div className="wrapper" style={bgColorStyle || undefined}>
      <div className="participants-wrapper desktop-only">
        {otherMember?.name && (
          <div className="participant">
            Reply with {otherMember.name}
          </div>
        )}
      </div>
      <Button variant="secondary" onClick={closeThread} className="desktop-only">
        <div><FaIcon icon={faXmark} size="lg" /></div>
      </Button>
      <Button variant="ghost" onClick={closeThread} className="mobile-only pl-0">
        <div className="mobile-thread-back spacing-3">
          <div
            className="mobile-thread-back-button"
            aria-label="Back"
          >
            <FaIcon icon={faChevronLeft} size="sm" style={colorStyle}/>
          </div>
          <div style={colorStyle || undefined}>Back</div>
        </div>
      </Button>
    </div>
  );
};

export default CustomThreadHeader;